<template>
    <div id="result-graphs">
        <v-row>
            <v-col cols="12" md="12" lg="4" xl="4" justify="center" align="center" style="padding-right:0;">
                <div style="border:4px solid #f5f5f5;">
                <v-row align="center" justify="center">
                    <v-col cols="12" md="12" lg="11" xl="11" justify="center" align="center" style="">
                        <div style="margin-left:20px;text-align:left;">
                            <h3 class="table-title">Chromosomal distribution</h3>
                        </div>
                    </v-col>
                </v-row>
                <v-row v-if="this.$store.getters.showSNVPlots" align="center" justify="center">

                    <!-- Biomarker Locations -->
                    <v-col cols="12" md="12" lg="12" xl="12" style="text-align:center;" align="center">
                        <div eager>
                             <v-card eager style="text-align:center;margin:0;padding:0;width:100%;" class="elevation-0">
                                            <div eager class="" @click="dialog_sunburst_1 = true"
                                                style="margin:auto;width:500px;height:480px;text-align:center;"
                                            >
                                                <div id="pos-all-thumb-1" v-html="this.$store.getters.getProcessState('load-genompos-1-thumb')" style="" eager></div>
                                                <div id="ideo-container-thumb" style="width:500px;"></div>
                                                <div eager id="chart-pos-1" class="chart" style="width:500px;height:200px;" ></div>

                                                <v-btn @click="dialog_chrom_1 = true" eager>
                                                    Show
                                                    <span style="width:10px;" eager></span>
                                                    <v-icon icon="mdi-arrow-expand" eager />
                                                </v-btn>
                                            </div>
                                        </v-card>

                                        <v-dialog v-model="dialog_chrom_1" eager>
                                            <v-card style="width:1600px;margin:auto;" eager>
                                                <v-btn @click="dialog_chrom_1 = false" eager>Close</v-btn>
                                                <div style="height:20px;" eager></div>
                                                <div id="ideo-container" style="width:1400px;height:1200px;" eager></div>
                                            </v-card>
                                        </v-dialog>
                        </div>
                    </v-col>

                </v-row>
                </div>
            </v-col>
            <!--<v-col cols="12" md="12" lg="4" xl="4" justify="center" align="center" style="padding-right:0;">
                    <div style="border:4px solid #f5f5f5;">
                    <v-row align="center" justify="center">
                        <v-col cols="12" md="12" lg="11" xl="11" justify="center" align="center" style="">
                            <div style="margin-left:20px;text-align:left;">
                                <h3 class="text-h5 font-weight-light">
                                    Variant pathogenicity
                                </h3>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row v-if="this.$store.getters.showSNVPlots" align="center" justify="center">
                        <v-col cols="12" md="12" lg="12" xl="12" style="text-align:center;">
                            <v-card eager class="elevation-0" style="width:100%;">
                                <div @click="dialog_patho_1 = true"
                                    style="margin:auto;height:480px;"
                                    >
                                    <div id="pathogenicity-all-thumb-1" v-html="this.$store.getters.getProcessState('load-patho-1-thumb')" style=""></div>
                                    <div id="chart-pathogenicity-1-thumb" class="chart" style="width:380px;height:380px;"></div>
                                    <v-btn @click="dialog_patho_1 = true">
                                        Show
                                        <span style="width:10px;"></span>
                                        <v-icon icon="mdi-arrow-expand" />
                                    </v-btn>
                                </div>
                            </v-card>

                            <v-dialog v-model="dialog_patho_1" eager>
                                <v-card style="width:1600px;margin:auto;" eager>
                                        <v-btn @click="dialog_patho_1 = false">Close</v-btn>
                                        <div style="height:20px;" eager></div>
                                        <div id="chart-pathogenicity-1" style="width:1000px;height:1200px;" eager></div>
                                </v-card>
                            </v-dialog>
                        </v-col>
                    </v-row>
                    </div>
            </v-col>-->
            <v-col cols="12" md="12" lg="8" xl="8" justify="center" align="center" style="padding-left:10;">
                <div style="border:4px solid #f5f5f5;">
                        <v-row align="center" justify="center" style="border:0px solid red;margin:0;padding:0;">
                            <v-col cols="12" md="12" lg="11" xl="11" justify="center" align="center" style="margin:0;padding:0;">
                                <div style="margin:0;padding:0;margin-left:20px;text-align:left;">
                                    <h3 class="table-title">Treatments</h3>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                        <!-- Clinical Significance -->
                        <v-col cols="12" md="12" lg="12" xl="12" style="text-align:center;">

                             <!--<div eager>
                                            <v-card eager style="text-align:center;margin:0;padding:0;" class="elevation-0">
                                                <div eager class="" @click="dialog_sunburst_1 = true"
                                                    style="margin:auto;text-align:center;"
                                                >
                                                    <h5 eager>
                                                        Clinical evidence
                                                    </h5>-->

                                                    <swiper :navigation="true" :modules="modules" class="mySwiper" style="margin:0;padding:0;">
                                                            <swiper-slide>
                                                                     <!-- Drug class sunburst plot -->
                                                                     <v-container eager  style="margin:0;padding:0;">
                                                                     <v-row align="center" justify="center" eager style="margin:0;padding:0;">
                                                                     <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;" eager>
                                                                        <div eager>
                                                                            <v-card eager style="text-align:center;margin:0;padding:0;width:450px;" class="elevation-0">
                                                                                <div eager class="" @click="dialog_sunburst_set_1 = true"
                                                                                    style="margin:auto;width:450px;height:480px;text-align:center;"
                                                                                >
                                                                                    <div class="plot-title">
                                                                                        Drug classes > Drugs > Evidence level > Citation ID
                                                                                    </div>

                                                                                    <div id="treatments-set-all-thumb-1" v-html="this.$store.getters.getProcessState('load-sunburst-biomarker-3-thumb')" style="" eager>
                                                                                    </div>
                                                                                    <div id="chart-sunburst-set-1-thumb" class="chart" style="width:500px;height:350px;" ></div>

                                                                                    <v-btn @click="dialog_sunburst_set_1 = true" eager>
                                                                                        Show
                                                                                        <span style="width:10px;" eager></span>
                                                                                        <v-icon icon="mdi-arrow-expand" eager />
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-card>

                                                                            <v-dialog v-model="dialog_sunburst_set_1" eager>
                                                                                <v-card style="width:1200px;margin:auto;" eager>
                                                                                    <v-btn @click="dialog_sunburst_set_1 = false" eager>Close</v-btn>
                                                                                    <div style="height:20px;" eager></div>
                                                                                    <div id="chart-sunburst-set-1" style="width:1000px;height:1200px;" eager></div>
                                                                                </v-card>
                                                                            </v-dialog>

                                                                        </div>
                                                                     </v-col>
                                                                     <!-- Cancer entity sunburst plot -->
                                                                     <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;">
                                                                        <div class="text-center">
                                                                            <v-card style="text-align:center;margin:0;padding:0;width:450px;" class="elevation-0">
                                                                                <div class="" @click="dialog_sunburst_set_2 = true"
                                                                                    style="margin:auto;width:500px;height:480px;"
                                                                                >
                                                                                    <div class="plot-title">
                                                                                        Cancer type > Evidence level > Drugs > Citation ID
                                                                                    </div>

                                                                                    <div id="treatments-all-thumb-2" v-html="this.$store.getters.getProcessState('load-sunburst-biomarker-4-thumb')" style=""></div>
                                                                                    <div id="chart-sunburst-set-2-thumb" class="chart" style="width:450px;height:350px;" ></div>
                                                                                    <v-btn @click="dialog_sunburst_set_2 = true">
                                                                                        Show
                                                                                        <span style="width:10px;"></span>
                                                                                        <v-icon icon="mdi-arrow-expand" />
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-card>

                                                                            <v-dialog v-model="dialog_sunburst_set_2" eager>
                                                                                <v-card style="width:1200px;margin:auto;">
                                                                                    <v-btn @click="dialog_sunburst_set_2 = false">Close</v-btn>
                                                                                    <div style="height:20px;"></div>
                                                                                    <div id="chart-sunburst-set-2" style="width:1000px;height:1200px;"></div>
                                                                                </v-card>
                                                                            </v-dialog>

                                                                        </div>
                                                                     </v-col>
                                                                     </v-row>
                                                                     </v-container>
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <!-- Drug class sunburst plot -->
                                                                     <v-container eager style="margin:0;padding:0;">
                                                                     <v-row align="center" justify="center" eager>
                                                                     <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;" eager>
                                                                        <div eager>


                                                                            <v-card eager style="text-align:center;margin:0;padding:0;width:500px;" class="elevation-0">
                                                                                <div eager class="" @click="dialog_sunburst_set_3 = true"
                                                                                    style="margin:auto;width:500px;height:480px;text-align:center;"
                                                                                >
                                                                                    <div class="plot-title">
                                                                                        Match Type > Drug classes > Drugs > Evidence level > Citation ID
                                                                                    </div>

                                                                                    <div id="treatments-all-thumb-3" v-html="this.$store.getters.getProcessState('load-sunburst-biomarker-3-thumb')" style="" eager></div>
                                                                                    <div eager id="chart-sunburst-set-3-thumb" class="chart" style="width:100%;height:350px;" ></div>

                                                                                    <v-btn @click="dialog_sunburst_set_3 = true" eager>
                                                                                        Show
                                                                                        <span style="width:10px;" eager></span>
                                                                                        <v-icon icon="mdi-arrow-expand" eager />
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-card>

                                                                            <v-dialog v-model="dialog_sunburst_set_3" eager>
                                                                                <v-card style="width:1200px;margin:auto;" eager>
                                                                                    <v-btn @click="dialog_sunburst_set_3 = false" eager>Close</v-btn>
                                                                                    <div style="height:20px;" eager></div>
                                                                                    <div id="chart-sunburst-set-3" style="width:1000px;height:1200px;" eager></div>
                                                                                </v-card>
                                                                            </v-dialog>

                                                                        </div>
                                                                     </v-col>
                                                                     <!-- Cancer entity sunburst plot -->
                                                                     <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;">
                                                                        <div class="text-center">
                                                                            <v-card style="text-align:center;margin:0;padding:0;width:500px;" class="elevation-0">
                                                                                <div class="" @click="dialog_sunburst_set_4 = true"
                                                                                    style="margin:auto;width:500px;height:480px;"
                                                                                >
                                                                                    <div class="plot-title">
                                                                                        Match Type > Drugs > Evidence level > Citation ID
                                                                                    </div>

                                                                                    <div id="treatments-all-thumb-4" v-html="this.$store.getters.getProcessState('load-sunburst-set-4-thumb')" style=""></div>
                                                                                    <div id="chart-sunburst-set-4-thumb" class="chart" style="width:500px;height:350px;" ></div>
                                                                                    <v-btn @click="dialog_sunburst_set_4 = true">
                                                                                        Show
                                                                                        <span style="width:10px;"></span>
                                                                                        <v-icon icon="mdi-arrow-expand" />
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-card>

                                                                            <v-dialog v-model="dialog_sunburst_set_4" eager>
                                                                                <v-card style="width:1200px;margin:auto;">
                                                                                    <v-btn @click="dialog_sunburst_set_4 = false">Close</v-btn>
                                                                                    <div style="height:20px;"></div>
                                                                                    <div id="chart-sunburst-set-4" style="width:1000px;height:1200px;"></div>
                                                                                </v-card>
                                                                            </v-dialog>

                                                                        </div>
                                                                     </v-col></v-row>
                                                                     </v-container>
                                                            </swiper-slide>
                                                            <swiper-slide>
                                                                <!-- Response type -->
                                                         <v-container style="margin:0;padding:0;">
                                                         <v-row align="center" justify="center">
                                                         <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;">
                                                            <div>


                                                                <v-card style="text-align:center;margin:0;padding:0;width:500px;" class="elevation-0">
                                                                    <div class="" @click="dialog_sunburst_set_5 = true"
                                                                        style="margin:auto;width:500px;height:480px;text-align:center;"
                                                                    >
                                                                        <div class="plot-title">
                                                                            Response type > Drug class > Drugs > Evidence level > Citation ID
                                                                        </div>

                                                                        <div id="treatments-all-thumb-5" v-html="this.$store.getters.getProcessState('load-sunburst-set-5-thumb')" style=""></div>
                                                                        <div id="chart-sunburst-set-5-thumb" class="chart" style="width:100%;height:350px;" ></div>

                                                                        <v-btn @click="dialog_sunburst_set_5 = true">
                                                                            Show
                                                                            <span style="width:10px;"></span>
                                                                            <v-icon icon="mdi-arrow-expand" />
                                                                        </v-btn>
                                                                    </div>
                                                                </v-card>

                                                                <v-dialog v-model="dialog_sunburst_set_5" eager>
                                                                    <v-card style="width:1200px;margin:auto;">
                                                                        <v-btn @click="dialog_sunburst_set_5 = false">Close</v-btn>
                                                                        <div style="height:20px;"></div>
                                                                        <div id="chart-sunburst-set-5" style="width:1000px;height:1200px;"></div>
                                                                    </v-card>
                                                                </v-dialog>

                                                            </div>
                                                         </v-col>
                                                         </v-row>
                                                         </v-container>
                                                            </swiper-slide>

                                                            <!-- patient match type, patient drug class -->
                                                            <swiper-slide>
                                                                <!-- Drug class sunburst plot -->
                                                                     <v-container eager style="margin:0;padding:0;">
                                                                     <v-row align="center" justify="center" eager>
                                                                     <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;" eager>
                                                                        <div eager>


                                                                            <v-card eager style="text-align:center;margin:0;padding:0;width:500px;" class="elevation-0">
                                                                                <div eager class="" @click="dialog_sunburst_set_3 = true"
                                                                                    style="margin:auto;width:500px;height:480px;text-align:center;"
                                                                                >
                                                                                    <div class="plot-title">
                                                                                        Patient > Match type > Evidence level > Citation ID
                                                                                    </div>

                                                                                    <div id="treatments-all-thumb-6" v-html="this.$store.getters.getProcessState('load-sunburst-biomarker-3-thumb')" style="" eager></div>
                                                                                    <div eager id="chart-sunburst-set-6-thumb" class="chart" style="width:100%;height:350px;" ></div>

                                                                                    <v-btn @click="dialog_sunburst_set_6 = true" eager>
                                                                                        Show
                                                                                        <span style="width:10px;" eager></span>
                                                                                        <v-icon icon="mdi-arrow-expand" eager />
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-card>

                                                                            <v-dialog v-model="dialog_sunburst_set_6" eager>
                                                                                <v-card style="width:1200px;margin:auto;" eager>
                                                                                    <v-btn @click="dialog_sunburst_set_6 = false" eager>Close</v-btn>
                                                                                    <div style="height:20px;" eager></div>
                                                                                    <div id="chart-sunburst-set-6" style="width:1000px;height:1200px;" eager></div>
                                                                                </v-card>
                                                                            </v-dialog>

                                                                        </div>
                                                                     </v-col>
                                                                     <!-- Cancer entity sunburst plot -->
                                                                     <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;">
                                                                        <div class="text-center">
                                                                            <v-card style="text-align:center;margin:0;padding:0;width:500px;" class="elevation-0">
                                                                                <div class="" @click="dialog_sunburst_set_4 = true"
                                                                                    style="margin:auto;width:500px;height:480px;"
                                                                                >
                                                                                    <div class="plot-title">
                                                                                        Patient > Drug Class > Evidence level > Citation ID
                                                                                    </div>

                                                                                    <div id="treatments-all-thumb-7" v-html="this.$store.getters.getProcessState('load-sunburst-set-4-thumb')" style=""></div>
                                                                                    <div id="chart-sunburst-set-7-thumb" class="chart" style="width:500px;height:350px;" ></div>
                                                                                    <v-btn @click="dialog_sunburst_set_7 = true">
                                                                                        Show
                                                                                        <span style="width:10px;"></span>
                                                                                        <v-icon icon="mdi-arrow-expand" />
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-card>

                                                                            <v-dialog v-model="dialog_sunburst_set_7" eager>
                                                                                <v-card style="width:1200px;margin:auto;">
                                                                                    <v-btn @click="dialog_sunburst_set_7 = false">Close</v-btn>
                                                                                    <div style="height:20px;"></div>
                                                                                    <div id="chart-sunburst-set-7" style="width:1000px;height:1200px;"></div>
                                                                                </v-card>
                                                                            </v-dialog>

                                                                        </div>
                                                                     </v-col></v-row>
                                                                     </v-container>
                                                            </swiper-slide>

                                                            <!-- patient id 2 -->
                                                            <!-- patient match type, patient drug class -->
                                                            <swiper-slide>
                                                                <!-- Drug class sunburst plot -->
                                                                     <v-container eager style="margin:0;padding:0;">
                                                                     <v-row align="center" justify="center" eager>
                                                                     <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;" eager>
                                                                        <div eager>


                                                                            <v-card eager style="text-align:center;margin:0;padding:0;width:500px;" class="elevation-0">
                                                                                <div eager class="" @click="dialog_sunburst_set_8 = true"
                                                                                    style="margin:auto;width:500px;height:480px;text-align:center;"
                                                                                >
                                                                                    <div class="plot-title">
                                                                                        Patient > Cancer type > Evidence level > Citation ID
                                                                                    </div>

                                                                                    <div id="treatments-all-thumb-8" v-html="this.$store.getters.getProcessState('load-sunburst-biomarker-3-thumb')" style="" eager></div>
                                                                                    <div eager id="chart-sunburst-set-8-thumb" class="chart" style="width:100%;height:350px;" ></div>

                                                                                    <v-btn @click="dialog_sunburst_set_8 = true" eager>
                                                                                        Show
                                                                                        <span style="width:10px;" eager></span>
                                                                                        <v-icon icon="mdi-arrow-expand" eager />
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-card>

                                                                            <v-dialog v-model="dialog_sunburst_set_8" eager>
                                                                                <v-card style="width:1200px;margin:auto;" eager>
                                                                                    <v-btn @click="dialog_sunburst_set_8 = false" eager>Close</v-btn>
                                                                                    <div style="height:20px;" eager></div>
                                                                                    <div id="chart-sunburst-set-8" style="width:1000px;height:1200px;" eager></div>
                                                                                </v-card>
                                                                            </v-dialog>

                                                                        </div>
                                                                     </v-col>
                                                                     <!-- Cancer entity sunburst plot -->
                                                                     <v-col cols="12" md="6" lg="4" xl="4" style="text-align:center;">
                                                                        <div class="text-center">
                                                                            <v-card style="text-align:center;margin:0;padding:0;width:500px;" class="elevation-0">
                                                                                <div class="" @click="dialog_sunburst_set_9 = true"
                                                                                    style="margin:auto;width:500px;height:480px;"
                                                                                >
                                                                                    <div class="plot-title">
                                                                                        Patient > Drugs > Evidence level > Citation ID
                                                                                    </div>

                                                                                    <div id="treatments-all-thumb-9" v-html="this.$store.getters.getProcessState('load-sunburst-set-9-thumb')" style=""></div>
                                                                                    <div id="chart-sunburst-set-9-thumb" class="chart" style="width:500px;height:350px;" ></div>
                                                                                    <v-btn @click="dialog_sunburst_set_9 = true">
                                                                                        Show
                                                                                        <span style="width:10px;"></span>
                                                                                        <v-icon icon="mdi-arrow-expand" />
                                                                                    </v-btn>
                                                                                </div>
                                                                            </v-card>

                                                                            <v-dialog v-model="dialog_sunburst_set_9" eager>
                                                                                <v-card style="width:1200px;margin:auto;">
                                                                                    <v-btn @click="dialog_sunburst_set_9 = false">Close</v-btn>
                                                                                    <div style="height:20px;"></div>
                                                                                    <div id="chart-sunburst-set-9" style="width:1000px;height:1200px;"></div>
                                                                                </v-card>
                                                                            </v-dialog>

                                                                        </div>
                                                                     </v-col></v-row>
                                                                     </v-container>
                                                            </swiper-slide>

                                                          </swiper>



                                                    <div id="treatments-all-thumb-1" v-html="this.$store.getters.getProcessState('load-sunburst-1-thumb')" style="" eager></div>
                                                    <!--<div eager id="chart" class="chart" style="width:100%;height:350px;" ></div>

                                                    <v-btn @click="dialog_sunburst_1 = true" eager>
                                                        Show
                                                        <span style="width:10px;" eager></span>
                                                        <v-icon icon="mdi-arrow-expand" eager />
                                                    </v-btn>-->
                                                <!--</div>
                                            </v-card>-->

                                            <!--<v-dialog v-model="dialog_sunburst_1" eager>
                                                <v-card style="width:1200px;margin:auto;" eager>
                                                    <v-btn @click="dialog_sunburst_1 = false" eager>Close</v-btn>
                                                    <div style="height:20px;" eager></div>
                                                    <div id="chart-sunburst-1" style="width:1000px;height:1200px;" eager></div>
                                                </v-card>
                                            </v-dialog>-->
                             <!--</div>-->

                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

//const slides = computed(() => ['1','3','5']);
const page=0

//const swiper = ref();

export default {
    name: 'BiomarkerPlots',
    data () {
      return {
         dialog_chrom_1 : false,
         dataAllPositions1: "",
         dialog_patho_1 : false,
         dataAllPathogenicity1: "",
         dialog_sunburst_1 : false,
         dataAllTreatmentsSunburst1: "",
         dialog_sunburst_set_1: false,
         dialog_sunburst_set_2: false,
         dialog_sunburst_set_3: false,
         dialog_sunburst_set_4: false,
         dialog_sunburst_set_5: false,
         dialog_sunburst_set_6: false,
         dialog_sunburst_set_7: false,
         dialog_sunburst_set_8: false,
         dialog_sunburst_set_9: false,
      }
    },
    components: {
      Swiper,
      SwiperSlide,
    },
    beforeCreate: async function() {
    },
    mounted: function () {

    },
    setup() {
      return {
        modules: [Navigation],
      };
    },
}

</script>
<style scoped>
  #ideo-container {
    height: 500px;
    width: 90%;
    margin: auto;
  }
  #ideo-container-thumb {
    height:180px;
    width: 100%;
    margin: auto;
  }
  .table-title {
    font-size: var(--font-600);
    font-family: var(--default-font);
    text-align: left;
    font-weight: 300;
    padding:5px;
    }
  .plot-title {
    font-size: var(--font-400);
    font-family: var(--default-font);
    text-align: left;
    font-weight: 300;
    padding:5px;
    }
</style>
